import { render, staticRenderFns } from "./CardUsersEditor.vue?vue&type=template&id=32a8570e&scoped=true"
import script from "./CardUsersEditor.vue?vue&type=script&lang=js"
export * from "./CardUsersEditor.vue?vue&type=script&lang=js"
import style0 from "./CardUsersEditor.vue?vue&type=style&index=0&id=32a8570e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8570e",
  null
  
)

export default component.exports